import { render, staticRenderFns } from "./teenagerSymptoms.vue?vue&type=template&id=0915fa56&scoped=true&"
import script from "./teenagerSymptoms.vue?vue&type=script&lang=js&"
export * from "./teenagerSymptoms.vue?vue&type=script&lang=js&"
import style0 from "./teenagerSymptoms.vue?vue&type=style&index=0&id=0915fa56&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0915fa56",
  null
  
)

export default component.exports